exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-block[data-v-2779a4a2]{padding:0 30px}.form-block .avatar-uploader-icon[data-v-2779a4a2]{font-size:28px;color:#8c939d;width:120px;height:120px;line-height:120px;text-align:center;border:1px dashed #d9d9d9;border-radius:6px;border-color:#409EFF}\n", ""]);

// exports
